import type { Menu } from '#/global'

import AnnouncementMenu from './modules/announcement.menu'
import AppVersionMenu from './modules/app-version.menu'
import LinkMenu from './modules/link.menu'
import MessageMenu from './modules/message.menu'
import MultilevelMenuExample from './modules/multilevel.menu.example'
import SystemMenu from './modules/system.menu'

const menu: Menu.recordMainRaw[] = [
  {
    meta: {
      title: '演示',
      icon: 'uim:box',
    },
    children: [
      MultilevelMenuExample,
    ],
  },
  {
    meta: {
      title: '友情链接',
      icon: 'i-ep:link',
    },
    children: [
      LinkMenu,
    ],
  },
  {
    meta: {
      title: '留言管理',
      icon: 'i-ep:message',
    },
    children: [
      MessageMenu,
    ],
  },
  {
    meta: {
      title: 'APP版本管理',
      icon: 'i-ep:mobile-phone',
    },
    children: [
      AppVersionMenu,
    ],
  },
  {
    meta: {
      title: '系统管理',
      icon: 'i-ep:setting',
    },
    children: [
      SystemMenu,
      AnnouncementMenu,
    ],
  },
]

export default menu
